import { useFilterTracking } from '~/shared/hooks/useEvents/useFilterTrackEvent';
import { useFilterState } from './useFilterState';

export const useDrawerFilterTracking = () => {
    const isAnyDrawerOpen = useFilterState(
        (state) => (state.isOpen && state.isDetailOpen) || state.openDropdownCount > 0,
    );

    return useFilterTracking({ enabled: !isAnyDrawerOpen });
};
